/**
 * @file
 * Main store.
 */

import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    filters: {
      multi: null,
    },
    page: 1,
    loading: true,
    errored: false,
  },
  mutations: {
    setFilters(state, filters) {
      state.filters = filters;
    },
    setLoading(state, value) {
      state.loading = value;
    },
    setErrored(state, value) {
      state.errored = value;
    },
    setPage(state, value) {
      state.page = value;
    },
  },
});

export default store;
